/* eslint-disable no-nested-ternary */
import React from 'react';

import { useHash } from '../hooks/useHash';

import Header from './Header';
import Breadcrumb from './Breadcrumb';
import Section from './Section';

function Page({ header, sections, articles, withBreadcrumb }) {
  // SCROLL TO SPECIFIC SECTION BASED ON URL HASH
  useHash();

  return (
    <>
      <Header header={header} />
      {sections.map((section, i) => (
        <Section
          key={`${section.contentful_id}-${i}`}
          section={section}
          articles={articles}
        />
      ))}
      {withBreadcrumb && (
        <div className="wrapper">
          <Breadcrumb />
        </div>
      )}
    </>
  );
}

export default Page;
